module.exports = __webpack_public_path__ + "static/img/PH.0791628.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/PH.svg
// module id = vW6Y
// module chunks = 66